import { render, staticRenderFns } from "./DetailJobLibraries.vue?vue&type=template&id=68144a1c&scoped=true"
import script from "./DetailJobLibraries.vue?vue&type=script&lang=js"
export * from "./DetailJobLibraries.vue?vue&type=script&lang=js"
import style0 from "./DetailJobLibraries.vue?vue&type=style&index=0&id=68144a1c&prod&scoped=true&lang=css"
import style1 from "./DetailJobLibraries.vue?vue&type=style&index=1&id=68144a1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68144a1c",
  null
  
)

export default component.exports